import { __assign } from "tslib";
import React, { useMemo } from 'react';
import { ReactPopper } from '../../PopperPopover/ReactPopper';
import { convertFromPopperPlacement, convertToPopperPlacement, } from '../../helpers';
import s from './BasePopper.scss';
var wrapperMaxWidth = parseInt(s['wrapper_max_width']);
/** This is our base popper wrapper that applies our custom modifiers etc */
var BasePopper = function (_a) {
    var modifiers = _a.modifiers, disablePlacementModifier = _a.disablePlacementModifier, placement = _a.placement, secondaryPlacement = _a.secondaryPlacement, positionFixed = _a.positionFixed, eventsEnabled = _a.eventsEnabled, referenceElement = _a.referenceElement, renderPopover = _a.renderPopover;
    var customModifiers = useMemo(function () { return (__assign({ overridePlacement: {
            /* This modifier will force the popover to not be centered when it reaches
               the max width, as per designers request. By default it sets the `start`
               placement variant when that is the case, but if the popover doesn't fit
               the built-in `flip` modifier will kick in and position it accordingly. */
            enabled: !disablePlacementModifier,
            order: 50,
            fn: function (data) {
                var width = data.offsets.popper.width;
                var maxWidth = disablePlacementModifier
                    ? Number.POSITIVE_INFINITY
                    : wrapperMaxWidth;
                var _a = data.placement.split('-'), basePlacement = _a[0], variantPlacement = _a[1];
                var finalPlacement = width >= maxWidth && !variantPlacement
                    ? basePlacement + "-start"
                    : data.placement;
                return __assign(__assign({}, data), { placement: finalPlacement });
            },
        } }, modifiers)); }, [disablePlacementModifier, modifiers]);
    return (React.createElement(ReactPopper, __assign({ placement: convertToPopperPlacement(placement, secondaryPlacement), eventsEnabled: eventsEnabled, positionFixed: positionFixed, modifiers: customModifiers }, (referenceElement ? { referenceElement: referenceElement } : {})), function (_a) {
        var popperPlacement = _a.placement, style = _a.style, arrowProps = _a.arrowProps, scheduleUpdate = _a.scheduleUpdate, ref = _a.ref;
        var _b = convertFromPopperPlacement(popperPlacement), effectivePlacement = _b.placement, effectiveSecondaryPlacement = _b.secondaryPlacement;
        return renderPopover({
            rootRef: ref,
            arrowRef: arrowProps === null || arrowProps === void 0 ? void 0 : arrowProps.ref,
            contentStyle: style,
            arrowStyle: arrowProps === null || arrowProps === void 0 ? void 0 : arrowProps.style,
            effectivePlacement: effectivePlacement,
            effectiveSecondaryPlacement: effectiveSecondaryPlacement,
            updatePositioning: scheduleUpdate,
        });
    }));
};
BasePopper.displayName = 'BasePopper';
export default BasePopper;
//# sourceMappingURL=BasePopper.js.map